"use client";
import { useEffect, useState } from "react";
import ContentLoader from "react-content-loader";
import { Col, Container, Row } from "reactstrap";
import PostLoader from "./postLoader";
export const Skeleton = () => {
  return (
    <Row>
      <Col>
        <div className="product-box">
          <div className="img-wrapper"></div>
          <PostLoader />
        </div>
      </Col>
      <Col>
        <div className="product-box">
          <div className="img-wrapper"></div>
          <PostLoader />
        </div>
      </Col>
      <Col>
        <div className="product-box">
          <div className="img-wrapper"></div>
          <PostLoader />
        </div>
      </Col>
      <Col>
        <div className="product-box">
          <div className="img-wrapper"></div>
          <PostLoader />
        </div>
      </Col>
    </Row>
  );
};

export const TextSkeleton = () => {
  return (
    <Container>
      <Row>
        <Col>
          <ContentLoader
            speed={2}
            width={600}
            height={124}
            viewBox="0 0 600 124"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="4" y="9" rx="3" ry="3" width="410" height="6" />
            <rect x="4" y="25" rx="3" ry="3" width="380" height="6" />
            <rect x="4" y="41" rx="3" ry="3" width="178" height="6" />
          </ContentLoader>
        </Col>
      </Row>
    </Container>
  );
};
export const ListSkeleton = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null; // Return null on server-side
  }
  if (typeof window !== "undefined") {
    return (
      <Container>
        <Row>
          <Col lg="12">
            <ContentLoader
              speed={2}
              width={400}
              height={124}
              viewBox="0 0 400 124"
              backgroundColor="#d4d4d4"
              foregroundColor="#ecebeb"
            >
              <rect x="20" y="8" rx="3" ry="3" width="250" height="6" />
              <rect x="5" y="6" rx="0" ry="0" width="10" height="10" />
              <rect x="20" y="27" rx="3" ry="3" width="250" height="6" />
              <rect x="5" y="25" rx="0" ry="0" width="10" height="10" />
              <rect x="20" y="44" rx="3" ry="3" width="250" height="6" />
              <rect x="5" y="42" rx="0" ry="0" width="10" height="10" />
              <rect x="20" y="63" rx="3" ry="3" width="250" height="6" />
              <rect x="5" y="61" rx="0" ry="0" width="10" height="10" />
              <rect x="20" y="80" rx="3" ry="3" width="250" height="6" />
              <rect x="5" y="78" rx="0" ry="0" width="10" height="10" />
              <rect x="20" y="97" rx="3" ry="3" width="250" height="6" />
              <rect x="5" y="95" rx="0" ry="0" width="10" height="10" />
              <rect x="20" y="116" rx="3" ry="3" width="250" height="6" />
              <rect x="5" y="114" rx="0" ry="0" width="10" height="10" />
            </ContentLoader>
          </Col>
        </Row>
      </Container>
    );
  }
};
